export default __webpack_public_path__ + "static/media/work4.02c5bd40.svg";